/**
 * @file   选择游戏模式
 * @create macaiqi 2025/07/15
 * @update 
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.scss'

export default function Choose() {
    const navigate = useNavigate()

    return (
        <div className='choose-page'>
            <div className="btnbox">
                <div className="btn b1" onClick={() => {
                    navigate({
                        pathname: '/LLK/LLKGame',
                        search: "?type=1"
                    })

                }}></div>
                <div className="btn b2" onClick={() => {
                    navigate({
                        pathname: '/LLK/LLKGame',
                        search: "?type=2"
                    })

                }}></div>
            </div>
            <div
                className="back"
                onClick={() => {
                    navigate('/LLK')
                }}
            />
        </div>
    )
}
